import React, { useEffect, useState } from "react";
import CustomButton from "./CustomButton";
import {
  ArrowDownTrayIcon,
  FolderPlusIcon,
  PaperClipIcon,
} from "@heroicons/react/24/outline";
import StatusForDrawer from "./StatusForDrawer";
import { useDocumentAllFiles, useDocumentFile } from "../custom-hooks/queries";
import JSZip from "jszip";
import moment from "moment";
import DownloadNotifications from "./Notifications/DownloadNotifications";

export const ReportContainer = ({ documents, status, vendorName }) => {
  const [downloadNotificationOpen, setDownloadNotificationOpen] =
    useState(false);
  const [fileName, setFileName] = useState("");
  const [downloadType, setDownloadType] = useState(null);

  const {
    mutate,
    data: files,
    isError: isFileError,
    error: errorMessageFile,
  } = useDocumentFile();

  const {
    mutate: allFilesDownload,
    data: allFiles,
    isError: allFilesError,
  } = useDocumentAllFiles();

  const handleDownload = (id, name, type) => {
    setFileName(name);
    setDownloadType(type);
    setDownloadNotificationOpen(true);
    mutate(id);
  };

  const handleDownloadAll = async (ids, type) => {
    setFileName(`DiligentPharmaAssessment-${vendorName}.zip`);
    setDownloadType(type);
    setDownloadNotificationOpen(true);

    allFilesDownload(ids);
  };

  const handleFileDownloadOnClick = () => {
    if (isFileError || allFilesError) return;

    // Prioritize multiple files if present
    if (allFiles?.length > 1 && downloadType === "all") {
      const zip = new JSZip();
      const nameCount = {}; // Track occurrences of filenames

      const promises = allFiles.map((file, index) =>
        fetch(file.download_link)
          .then((res) => res.blob())
          .then((blob) => {
            let baseName = documents?.[index]?.document_name || `file_${index}`;

            // Ensure unique filenames
            if (nameCount[baseName]) {
              nameCount[baseName] += 1;
            } else {
              nameCount[baseName] = 1;
            }

            const uniqueFileName = `${baseName.split(".")[0]}-${moment().format(
              "MM-DD-YYYY"
            )}.pdf`;

            zip.file(uniqueFileName, blob);
          })
      );

      Promise.all(promises).then(() => {
        zip.generateAsync({ type: "blob" }).then((zipBlob) => {
          const zipLink = document.createElement("a");
          zipLink.href = URL.createObjectURL(zipBlob);
          zipLink.setAttribute(
            "download",
            `DiligentPharmaAssessment-${vendorName}-${moment().format(
              "MM-DD-YYYY"
            )}.zip`
          );
          document.body.appendChild(zipLink);
          zipLink.click();
          document.body.removeChild(zipLink);
        });
      });
    } else if (files?.download_link && downloadType === "single") {
      // Single file download
      const link = document.createElement("a");
      link.href = files.download_link;
      link.download = "file.pdf"; // Optional filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  // useEffect(() => {
  //   if (allFilesError) {
  //     //   setShow(true);
  //     return;
  //   }

  //   if (allFiles?.length) {
  //     const zip = new JSZip();
  //     const nameCount = {}; // Track occurrences of filenames

  //     const promises = allFiles.map((file, index) =>
  //       fetch(file.download_link)
  //         .then((res) => res.blob())
  //         .then((blob) => {
  //           let baseName = documents?.[index]?.document_name || `file_${index}`;

  //           // Ensure unique filenames
  //           if (nameCount[baseName]) {
  //             nameCount[baseName] += 1;
  //             baseName = `${baseName}`;
  //           } else {
  //             nameCount[baseName] = 1;
  //           }

  //           // Append timestamp to make sure it's unique
  //           const uniqueFileName = `${baseName.split(".")[0]}-${moment().format(
  //             "MM-DD-YYYY"
  //           )}.pdf`;

  //           zip.file(uniqueFileName, blob);
  //         })
  //     );

  //     Promise.all(promises).then(() => {
  //       zip.generateAsync({ type: "blob" }).then((zipBlob) => {
  //         const zipLink = document.createElement("a");
  //         zipLink.href = URL.createObjectURL(zipBlob);
  //         zipLink.setAttribute(
  //           "download",
  //           `DiligentPharmaAssessment-${vendorName}-${moment().format(
  //             "MM-DD-YYYY"
  //           )}.zip`
  //         );
  //         document.body.appendChild(zipLink);
  //         zipLink.click();
  //         document.body.removeChild(zipLink);
  //       });
  //     });
  //   }
  // }, [allFiles, allFilesError]);

  // useEffect(() => {
  //   if (isFileError) {
  //     //   setShow(true);
  //     return;
  //   }
  //   if (files?.download_link) {
  //     const link = document.createElement("a");
  //     link.href = files.download_link;
  //     link.download = "file.pdf"; // Set the filename (optional)
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   }
  // }, [files, isFileError]);

  return (
    <div className="border border-gray-300 rounded-md py-4 sm:py-5 custom-breakpoint-7:py-5 custom-breakpoint-9:py-6 bg-slate-50 min-w-0">
      <div className="border-b border-gray-300 flex flex-col sm:flex-row flex-wrap justify-between items-stretch sm:items-center gap-3 px-3 sm:px-5 custom-breakpoint-7:px-5 custom-breakpoint-9:px-6 pb-2">
        <h1 className="font-semibold text-md">Reports</h1>
        {documents?.length > 0 && (
          <div className="flex-shrink-0">
            <CustomButton
              icon={<ArrowDownTrayIcon className="w-4 h-4" />}
              width={documents.length > 1 ? "w-40" : "w-32"}
              height={"h-10"}
              color={
                status === "Canceled Assessment" || status === "Canceled"
                  ? "bg-gray-400"
                  : "bg-white border border-gray-300"
              }
              textColor={
                status === "Canceled Assessment" || status === "Canceled"
                  ? "text-white"
                  : "text-gray-700"
              }
              text={
                documents.length > 1
                  ? `Download All (${documents.length})`
                  : "Download"
              }
              onClick={() =>
                handleDownloadAll(
                  documents?.map((doc) => doc.document_id),
                  "all"
                )
              }
              disabled={
                status === "Canceled Assessment" || status === "Canceled"
              }
            />
          </div>
        )}
      </div>

      {documents?.length === 0 ? (
        <div className="flex flex-col items-center mt-5">
          <span className="flex justify-center items-center">
            <FolderPlusIcon className="w-10 h-10 text-gray-300" />
          </span>
          <p className="mt-3 text-gray-700 text-sm font-semibold">No Reports</p>
        </div>
      ) : (
        <div className="py-4 sm:py-5 custom-breakpoint-7:py-5 custom-breakpoint-9:p-6 px-3 sm:p-5">
          {documents?.map((item) => (
            <div
              key={item.document_id}
              className="flex items-center justify-between gap-2 border-b border-gray-300 py-4 sm:py-5"
            >
              <div className="flex items-center gap-2 min-w-0 pr-2">
                <PaperClipIcon className="w-5 h-5 text-gray-500 font-semibold flex-shrink-0" />
                <div className="flex flex-col flex-grow min-w-0">
                  <p className="text-sm font-medium break-words truncate">
                    {item?.document_name.split(".")[0]}
                  </p>
                  <p className="text-xs font-medium mt-1 flex-shrink-0 w-max">
                    <StatusForDrawer statusName={item.document_sub_type} />
                  </p>
                </div>
              </div>
              <button
                disabled={
                  status === "Canceled Assessment" || status === "Canceled"
                }
                className={`text-sm font-semibold text-gray-600 ${
                  status === "Canceled" || status === "Canceled Assessment"
                    ? "cursor-not-allowed"
                    : "cursor-pointer"
                }`}
                onClick={() => {
                  if (
                    status !== "Canceled Assessment" ||
                    status !== "Canceled"
                  ) {
                    handleDownload(
                      item?.document_id,
                      item?.document_name,
                      "single"
                    );
                  }
                }}
              >
                <ArrowDownTrayIcon className="w-8 h-8 p-1 text-gray-600" />
              </button>
            </div>
          ))}
        </div>
      )}

      <div
        className={`text-center py-2 flex ${
          documents?.length > 0 ? "justify-end" : "justify-center"
        } px-3.5 mt-3`}
      ></div>

      <DownloadNotifications
        show={downloadNotificationOpen}
        setShow={setDownloadNotificationOpen}
        fileType={"assessmentDetails"}
        name={fileName}
        // id={id}
        download={handleFileDownloadOnClick}
      />
    </div>
  );
};
